import AutoCompleteField from '@Fields/AutoCompleteField';
import SelectField from '@Fields/SelectField';
import TextField from '@Fields/TextField';
import LocationPickerField from '@Fields/LocationPickerField';

class ListingDetailAircraftForm extends React.Component {

    constructor(props) {
        super(props);

        this.handleFieldChanged = this.handleFieldChanged.bind(this);
        this.UpdateCategoryList = this.UpdateCategoryList.bind(this);
        this.updateMakeModel = this.updateMakeModel.bind(this);
        this.UpdateSpecList = this.UpdateSpecList.bind(this);

        this.state = props.model;
        this.state.bAutofillRendered = false;

        //updates the parent's validator to use this method 
        var state = this.state;
        state.updateMakeModel = this.updateMakeModel
        this.props.handleFormUpdate(state);
    }

    //will execute this setState AFTER the state has received all the props. 
    componentDidMount() {
        this.SNIsRequired({ ...this.state }, true);
    }

    componentWillReceiveProps(Props) {
        this.setState({
            ManufacturerSelected: Props.model.ManufacturerSelected,
            ModelSelected: Props.model.ModelSelected,
            SerialVIN: Props.model.SerialVIN,
            YearSelected: Props.model.YearSelected,
            CategorySelected: Props.model.CategorySelected,
            CategoriesList: Props.model.CategoriesList,
            validFECat: Props.model.validFECat,
            FleetEvalElement: Props.model.FleetEvalElement,
            MakeOnlyCategoryOptions: Props.model.MakeOnlyCategoryOptions,
            allCategoryOptions: Props.model.allCategoryOptions,
            InventoryType: Props.model.InventoryType,
            BaseCatID: Props.model.BaseCatID,
            specsViewModel: Props.specsViewModel,
            HighlightErrors: Props.model.HighlightErrors,
            FormErrors: Props.model.FormErrors,
            InputErrors: Props.model.InputErrors,
            MLAutofilled: Props.model.MLAutofilled,
            AutofilledFields: Props.model.AutofilledFields
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.CategorySelected !== this.state.CategorySelected) {
            this.UpdateSpecList(this.state);
        }
    }

    handleFormUpdate(Model) {
        this.setState({
            specsViewModel: Model.specsViewModel,
            SystemOfMeasurement: Model.SystemOfMeasurement,
            ManufacturerSelected: Model.ManufacturerSelected,
            ManufacturersList: Model.ManufacturersList,
            ModelSelected: Model.ModelSelected,
            ModelList: Model.ModelList,
            CategorySelected: Model.CategorySelected,
            CategoriesList: Model.CategoriesList,
            allCategoryOptions: Model.allCategoryOptions,
            MakeOnlyCategoryOptions: Model.MakeOnlyCategoryOptions,
            SerialVIN: Model.SerialVIN,
            SNRequired: Model.SNRequired,
            SerialVINSelection: Model.SerialVINSelection,
            TailNumber: Model.TailNumber,
            AllYears: Model.AllYears,
            YearSelected: Model.YearSelected,
            Years: Model.Years,
            EquipmentIdentifier: Model.EquipmentIdentifier,
            StockNumber: Model.StockNumber,
            Condition: Model.Condition,
            Description: Model.Description,
            BaseCatID: Model.BaseCatID,
            Quantity: Model.Quantity,
            Weight: Model.Weight,
            FleetEvalElement: Model.FleetEvalElement,
            ValidFECategories: Model.ValidFECategories,
            validFECat: Model.validFECat,
            ShowFE: Model.ShowFE,
            VinSerialVerify: Model.VinSerialVerify,
            bManufacturerIsRequired: Model.bManufacturerIsRequired,
            bModelIsRequired: Model.bModelIsRequired,
            bYearIsRequired: Model.bYearIsRequired,
            HighlightErrors: Model.HighlightErrors,
            FormErrors: Model.FormErrors,
            InputErrors: Model.InputErrors,
            MLAutofilled: Model.MLAutofilled,
            AutofilledFields: Model.AutofilledFields
        });
    }

    handleFieldChanged(field, value, updateCat) {
        var state = this.state;
        state[field] = value;

        switch (field) {
            case "ManufacturerSelected":
                if (state.ManufacturerSelected != null && state.ManufacturerSelected.length >= 2) {
                    var objectToSend = {
                        Manufacturer: state.ManufacturerSelected,
                        Category: state.CategorySelected,
                        BaseCategoryID: state.BaseCatID,
                    }

                    var xhr1 = new XMLHttpRequest();
                    xhr1.onload = function () {
                        state = this.state;
                        if (xhr1.status == 200) {
                            var response = JSON.parse(xhr1.response);

                            state.ManufacturerSelected = this.state.ManufacturerSelected
                            if (response.TypedText == state.ManufacturerSelected) {
                                state.ManufacturersList = response.Manufacturers;
                            }
                            else {
                                state.ManufacturersList = this.state.ManufacturersList;
                            }

                            if (updateCat)
                                state = this.UpdateCategoryList(state);
                            else
                                this.handleFormUpdate(state);
                        }
                    }.bind(this);

                    xhr1.open("POST", '/listinginput/ajax/UpdateManufacturerList', true);
                    xhr1.setRequestHeader("Content-type", "application/json");
                    xhr1.send(JSON.stringify(objectToSend));
                }
                else {
                    state.ManufacturerSelected = this.state.ManufacturerSelected;
                    state.ManufacturersList = [];
                }

                if (state.ManufacturerSelected == "") {
                    state.CategoriesList = state.allCategoryOptions;
                    this.props.handleCategoryUpdate(state);
                }

                var bIsInList = jQuery.inArray(state.ManufacturerSelected, state.ManufacturersList)
                if (bIsInList != -1)
                    this.props.handleFormUpdate(state);

                if (state.AutofilledFields.includes("Manufacturer")) {
                    state.AutofilledFields = state.AutofilledFields.filter(function (s) { return s != "Manufacturer"; });
                }

                this.handleFormUpdate(state);
                this.props.handleMasterViewUpdate(state);
                break;
            case "ModelSelected":
                if (state.ManufacturerSelected != null && state.ManufacturerSelected.trim() != "" && state.ManufacturerSelected.length >= 2 &&
                    state.ModelSelected != null && state.ModelSelected.trim() != "" && state.ModelSelected.length >= 2) {
                    var objectToSend = {
                        Model: state.ModelSelected,
                        Manufacturer: state.ManufacturerSelected,
                        Category: state.CategorySelected,
                        BaseCategoryID: state.BaseCatID,
                    }

                    var xhr2 = new XMLHttpRequest();
                    xhr2.onload = function () {
                        state = this.state;
                        if (xhr2.status == 200) {
                            var response = JSON.parse(xhr2.response);

                            state.ModelSelected = this.state.ModelSelected
                            if (response.TypedText == state.ModelSelected) {
                                state.ModelList = response.Models;
                            }
                            else {
                                state.ModelList = this.state.ModelList;
                            }

                            if (updateCat)
                                state = this.UpdateCategoryList(state);
                            else
                                this.handleFormUpdate(state);
                        }
                    }.bind(this);

                    xhr2.open("POST", '/listinginput/ajax/UpdateModelList', true);
                    xhr2.setRequestHeader("Content-type", "application/json");
                    xhr2.send(JSON.stringify(objectToSend));

                    var bIsInList = jQuery.inArray(state.ModelSelected, state.ModelList)
                    if (bIsInList != -1)
                        this.props.handleFormUpdate(state);
                }
                else {
                    state.ModelList = [];
                }

                if (state.AutofilledFields.includes("Model")) {
                    state.AutofilledFields = state.AutofilledFields.filter(function (s) { return s != "Model"; });
                }

                this.handleFormUpdate(state);
                this.props.handleMasterViewUpdate(state);
                break;
            case "CategorySelected":
                //state = this.ValidFECategory(state);
                state = this.SNIsRequired(state);

                //Make the specs section start over
                if ($(".toggle-details-2").is(":visible")) {
                    AdditionalDetailsToggle(true)
                }

                //if that field has an error, remove it until they validate again.
                if (state.HighlightErrors[field] == true) {
                    delete state.HighlightErrors[field];
                    delete state.InputErrors[field];

                    //year/serialVin form error case
                    if (field == "SerialVIN" || field == "YearSelected") {
                        state.FormErrors = [];
                    }

                    this.setState({
                        HighlightErrors: state.HighlightErrors,
                        InputErrors: state.InputErrors,
                        FormErrors: state.FormErrors,
                    });
                }

                if (state.AutofilledFields.includes("Category") && state.bAutofillRendered) {
                    state.CategorySelected = this.state.CategorySelected;
                    state.AutofilledFields = state.AutofilledFields.filter(function (s) { return s != "Category"; });
                }

                this.props.handleCategoryUpdate(state);
                this.CheckCatRequirements(state);
                this.UpdateSpecList(state);
                break;
            case "YearSelected":        //for dropdowns and radios to update object xml
                //if that field has an error, remove it until they validate again.
                if (state.HighlightErrors[field] == true) {
                    delete state.HighlightErrors["YearSelected"];
                    delete state.InputErrors["YearSelected"];
                    delete state.HighlightErrors["SerialVIN"];
                    delete state.InputErrors["SerialVIN"];

                    state.FormErrors = [];

                    this.setState({
                        HighlightErrors: state.HighlightErrors,
                        InputErrors: state.InputErrors,
                        FormErrors: state.FormErrors,
                    });
                }

                if (state.AutofilledFields.includes("Year")) {
                    state.AutofilledFields = state.AutofilledFields.filter(function (s) { return s != "Year"; });
                }

                this.props.handleFormUpdate(state);
                break;
            case "SerialVIN":
                if (state.AutofilledFields.includes("SerialVIN")) {
                    state.AutofilledFields = state.AutofilledFields.filter(function (s) { return s != "SerialVIN"; });
                }

                this.props.handleFormUpdate(state);
                break;
            case "SystemOfMeasurement":
            case "Condition":
                this.handleFormUpdate(state);
                break;
            case "SpecField":
                var spec = this.state.specsViewModel.oMMMCategoryGroupSpecs[this.state.specsViewModel.GroupIndex].Specs[this.state.specsViewModel.SpecIndex];

                state.specsViewModel = this.state.specsViewModel;
                state.specsViewModel.FormInputs[spec.SpecField].Value = value;

                this.handleFormUpdate(state);
                break;
            case "SpecUnit":
                var spec = this.state.specsViewModel.oMMMCategoryGroupSpecs[this.state.specsViewModel.GroupIndex].Specs[this.state.specsViewModel.SpecIndex];

                state.specsViewModel = this.state.specsViewModel;
                state.specsViewModel.FormInputs[spec.SpecField + "unit#"].Value = value;

                state.specsViewModel = this.props.showUnitSwitchModal(state.specsViewModel, spec, spec.SpecField + "unit#", value);

                state.SpecsViewModel = state.specsViewModel;
                state.SpecsViewModel.InputErrors = {};
                state.SpecsViewModel.HighlightErrors = {};

                this.handleFormUpdate(state);
                this.props.handleMasterViewUpdate(state);
                break;
            default:
                this.handleFormUpdate(state);
                break;
        }
    }

    handleOnBlur(field, e) {
        var state = this.state;

        if (field == "ModelSelected" || field == "ManufacturerSelected") {
            if (e.target.value) {
                var value = e.target.value.toUpperCase();
                state[field] = value;
                this.setState({
                    [field]: value,
                })
            }

            //update category list
            this.UpdateCategoryList(this.state);
        }

        if (field == "TailNumber") {
            if (state.specsViewModel.FormInputs["RegNumber"] != null) {
                state.specsViewModel.FormInputs["RegNumber"].Value = state.TailNumber;
                state.SpecsViewModel = state.specsViewModel;
            }
        }

        //if that field has an error, remove it until they validate again.
        if (state.HighlightErrors[field] == true) {
            delete state.HighlightErrors[field];
            delete state.InputErrors[field];

            //year/serialVin form error case
            if (field == "SerialVIN" || field == "YearSelected") {
                state.FormErrors = [];
            }

            this.setState({
                HighlightErrors: state.HighlightErrors,
                InputErrors: state.InputErrors,
                FormErrors: state.FormErrors,
            });
        }

        this.props.handleFormUpdate(state);
    }

    handleOnBlurUpdate(e) {
        var state = this.state;
        if (e.target.id == "serialvin" && this.state.SerialVIN == "") {
            state.Years = state.AllYears;
        }
        this.props.handleFormUpdate(state);
    }

    handleButtonClickOnForm(button) {
        var state = this.state;

        switch (button) {
            case "allCats":
                state.CategoriesList = state.allCategoryOptions;

                //for mobile, remove the hover color
                var btn = document.getElementById("allcats");
                btn.classList.remove("hover");

                this.props.handleCategoryUpdate(state);
                break;
            case "serialvin":
                this.GetSerialVINListingDetails(state)

                //for mobile, remove the hover color
                var btn = document.getElementById("serialvin");
                btn.classList.remove("hover");
                break;
        }
    }

    UpdateXMLImmediately() {
        var state = this.state;

        var objectToSend = {
            SystemOfMeasurement: state.SystemOfMeasurement,
            ManufacturerSelected: state.ManufacturerSelected,
            ModelSelected: state.ModelSelected,
            SerialVIN: state.SerialVIN,
            YearSelected: state.YearSelected,
            EquipmentIdentifier: state.EquipmentIdentifier,
            StockNumber: state.StockNumber,
            Condition: state.Condition,
            Description: state.Description,
            Quantity: state.Quantity,
            Weight: state.Weight,
            CategorySelected: state.CategorySelected,
            BaseCatID: state.BaseCatID
        }

        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/listinginput/listingdetail/savexml' + this.state.QueryString, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    //call to serialvin api.
    GetSerialVINListingDetails(state) {

        var highlightErrors = {};
        var formErrors = [];
        var inputErrors = {};

        //pass in serialvin and basecat into 
        if (state.SerialVIN != null && state.SerialVIN != "") {
            var regexp = new RegExp("^[0-9A-Za-z.-]+$");
            if (/\S/.test(state.SerialVIN.trim()) && regexp.test(state.SerialVIN.trim())) {
                Spinner.Show($('#pagebody'), true);

                var that = this;
                setTimeout(function () {

                    var objectToSend = {
                        SerialVIN: state.SerialVIN,
                        EquipmentIdentifier: state.EquipmentIdentifier,
                    };

                    var xhr3 = new XMLHttpRequest();
                    xhr3.onload = function () {
                        state = this.state;
                        var response = JSON.parse(xhr3.response);

                        //if there is a result, set the values. Otherwise, display to user that there was not a match
                        if (response.oListingDetailViewModel.ManufacturerSelected != "") {
                            state.HighlightErrors = {};
                            state.InputErrors = {};
                            state.FormErrors = [];

                            state.ManufacturerSelected = response.oListingDetailViewModel.ManufacturerSelected == "" ? state.ManufacturerSelected : response.oListingDetailViewModel.ManufacturerSelected;
                            state.ModelSelected = response.oListingDetailViewModel.ModelSelected == "" ? state.ModelSelected : response.oListingDetailViewModel.ModelSelected;
                            state.YearSelected = response.oListingDetailViewModel.YearSelected == "" ? state.YearSelected : response.oListingDetailViewModel.YearSelected;
                            state.Years = response.oListingDetailViewModel.Years.length > 1 ? response.oListingDetailViewModel.Years : state.Years;
                            state.CategorySelected = response.oListingDetailViewModel.CategorySelected == "" ? state.CategorySelected : response.oListingDetailViewModel.CategorySelected;
                            if (response.oListingDetailViewModel.categories != null)
                                state.categories = response.oListingDetailViewModel.categories.length > 1 ? response.oListingDetailViewModel.categories : state.categories;
                            else
                                state = this.UpdateCategoryList(state);
                        }
                        else {
                            inputErrors.SerialVINResults = that.state.Translations["NoResults"];

                            state.HighlightErrors = highlightErrors;
                            state.InputErrors = inputErrors;
                            state.FormErrors = formErrors;
                        }

                        setTimeout(function () {
                            Spinner.Remove();

                            that.props.handleFormUpdate(state);
                            that.props.handleCategoryUpdate(state);
                        }, 1000);

                    }.bind(that);

                    xhr3.open("POST", '/listinginput/ajax/GetSerialVINListingDetails', false);
                    xhr3.setRequestHeader("Content-type", "application/json");
                    xhr3.send(JSON.stringify(objectToSend));
                }, 1);
            }
            else {
                inputErrors.SerialVINResults = state.Translations["Invalid"];

                state.HighlightErrors = highlightErrors;
                state.InputErrors = inputErrors;
                state.FormErrors = formErrors;

                this.props.handleFormUpdate(state);
            }
        }
        else {
            this.props.handleFormUpdate(state);
        }
    }

    ValidFECategory(state) {

        //if the cat id is a valid FE category, highlight year and VIN
        var catid = parseInt(state.CategorySelected, 10);
        var key = 0;

        if (state.ValidFECategories.indexOf(catid) > -1 && state.ShowFE) {
            state.validFECat = true;

            var newElement = [];
            newElement.push(<div className="recommended-specs center-content"><span key={key} className="recommended-specs center-content">{this.getTranslation("RecommendSpecs")}"<div className="fe-indicator"></div>" </span></div>);
            state.FleetEvalElement = newElement;
        }
        else {
            state.validFECat = false;
            var newElement = [];
            newElement.push(<span key={key} className="no-recommended-specs center-content" style={{ display: 'none' }}> </span>);
            state.FleetEvalElement = newElement;
        }

        return state;
    }

    SNIsRequired(state, async) {

        if (state.CategorySelected != "" && state.CategorySelected.trim() != "0") {
            var objectToSend = {
                sCategory: state.CategorySelected,
            }

            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var response = JSON.parse(xhr.response);
                state.SNRequired = response.bRequiresSN;
                if (async) this.handleFormUpdate(state);
            }.bind(this);

            xhr.open("POST", '/listinginput/ajax/CategoryRequiresSN', async);
            xhr.setRequestHeader("Content-type", "application/json");
            xhr.send(JSON.stringify(objectToSend));
        }
        else {
            //most aircraft require a serial number so start the page with it required
            state.SNRequired = true;
            if (async) this.handleFormUpdate(state);
        }

        return state;
    }

    UpdateSpecList(passedState, bUndoMLAutofill) {
        var state = this.state;

        var objectToSend = {
            Manufacturer: passedState.ManufacturerSelected,
            Model: passedState.ModelSelected,
            SerialVIN: state.SerialVIN,
            Year: state.YearSelected,
            Category: passedState.CategorySelected,
            QueryString: state.QueryString,
            SystemOfMeasurement: state.SystemOfMeasurement,
            FormInputs: state.specsViewModel.FormInputs
        }

        var biggerObjectToSend = {
            oSpecsViewModel: objectToSend,
            bUndoMLAutofill: bUndoMLAutofill ?? false
        }

        var xhr2 = new XMLHttpRequest();
        xhr2.onload = function () {
            state = this.state;
            var response = JSON.parse(xhr2.response);
            state.specsViewModel = response.oSpecsViewModel;
            state.specsViewModel.InputErrors = {};
            state.specsViewModel.HighlightErrors = {};
            this.props.handleMasterViewUpdate(state);
        }.bind(this);

        xhr2.open("POST", '/listinginput/specs/LoadSpecs' + state.QueryString, true);
        xhr2.setRequestHeader("Content-type", "application/json");
        xhr2.send(JSON.stringify(biggerObjectToSend));
    }

    CheckCatRequirements(state) {
        var objectToSend = {
            CategorySelected: state.CategorySelected,
            QueryString: state.QueryString,
        }

        var xhr2 = new XMLHttpRequest();
        xhr2.onload = function () {
            var response = JSON.parse(xhr2.response);
            state = this.state;
            state.bManufacturerIsRequired = response.bManufacturerIsRequired;
            state.bModelIsRequired = response.bModelIsRequired;
            state.bYearIsRequired = response.bYearIsRequired;
            this.props.handleCategoryUpdate(state);
        }.bind(this);

        xhr2.open("POST", '/listinginput/ajax/CheckCatRequirements' + state.QueryString, true);
        xhr2.setRequestHeader("Content-type", "application/json");
        xhr2.send(JSON.stringify(objectToSend));
    }

    UpdateCategoryList(state, e) {
        var newCategoryList = state.allCategoryOptions;
        var currentCategory = this.state.CategorySelected;

        if (state.allCategoryOptions != state.MakeOnlyCategoryOptions)
            newCategoryList = state.MakeOnlyCategoryOptions

        if (state.ManufacturerSelected != null && state.ModelSelected != null) {
            var objectToSend = {};
            if (state.ManufacturerSelected == "") {
                objectToSend = {
                    BaseCategoryID: state.BaseCatID,
                };
            }
            else if (state.ModelSelected == "") {
                objectToSend = {
                    BaseCategoryID: state.BaseCatID,
                    Manufacturer: state.ManufacturerSelected,
                };
            }
            else {
                objectToSend = {
                    BaseCategoryID: state.BaseCatID,
                    Manufacturer: state.ManufacturerSelected,
                    Model: state.ModelSelected,
                };
            }

            var xhr3 = new XMLHttpRequest();
            xhr3.onload = function (e) {
                var response;
                if (xhr3.status == 200) {
                    response = JSON.parse(xhr3.response);
                }
                else {
                    return;
                }

                if (response.categories.length > 0 && response.categories.length != 1)
                    newCategoryList = response.categories;
                else if (response.categories.length == 1 && response.categories[0].Text != "")
                    newCategoryList = response.categories;

                // If CategoryIDToAutoSelect was returned, then select that category
                if (response.CategoryIDToAutoSelect) {
                    state.CategorySelected = $.grep(newCategoryList, function (cat) { return cat.Value == response.CategoryIDToAutoSelect; })[0].Value;
                    state = this.SNIsRequired(state);
                    this.setState({
                        SNRequired: state.SNRequired,
                    });
                }
                else {
                    newlist = newCategoryList.filter(function (cat) { return state.CategorySelected != 0 && cat.Value == state.CategorySelected && cat.Enabled; });
                    if (newlist.length == 1) {
                        state.CategorySelected = newlist[0].Value;
                        state = this.SNIsRequired(state);
                        this.setState({
                            SNRequired: state.SNRequired,
                        });
                    }
                }

                state.CategoriesList = newCategoryList;

                if (e.target.id == "ManufacturerSelected" || (state.CategoriesList.length > 0 && state.CategoriesList.length != 1)) {
                    if (state.CategoriesList.length > 0 && state.CategoriesList.length != 1)
                        state.MakeOnlyCategoryOptions = state.CategoriesList;
                    else if (state.CategoriesList.length == 1 && state.CategoriesList[0].Text != "")
                        state.MakeOnlyCategoryOptions = state.CategoriesList;
                    else
                        state.MakeOnlyCategoryOptions = state.allCategoryOptions;

                }

                //for marketbook or auctiontime/auctionvalues, switch inventory type
                if (state.CurrentSite == "MarketBook" || state.CurrentSite == "AuctionTime" || state.CurrentSite == "AuctionValues") {
                    if (response.nInventoryType == 0) {
                        state.InventoryType = 4;
                    }
                    else {
                        state.InventoryType = response.nInventoryType;
                    }
                    state.allCategoryOptions = response.AllCategoriesList;
                }

                if (response.bModelIsRequired != null)
                    state.bModelIsRequired = response.bModelIsRequired;

                this.UpdateXMLImmediately();

                this.props.handleCategoryUpdate(state);

                //Update Spec List
                if (currentCategory != state.CategorySelected && state.CategorySelected != "0")
                    this.UpdateSpecList(state);

            }.bind(this);

            xhr3.open("POST", '/listinginput/ajax/UpdateCategoryList', true);
            xhr3.setRequestHeader("Content-type", "application/json");
            xhr3.send(JSON.stringify(objectToSend));
        }
    }

    updateMakeModel(updatedState) {
        var state = this.state;

        state.ManufacturerSelected = updatedState.ManufacturerSelected;
        state.ModelSelected = updatedState.ModelSelected;
        state.CategorySelected = updatedState.CategorySelected;

        this.handleFormUpdate(state);
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    RemoveMLAutofillData() {
        var state = this.state;
        state.MLAutofilled = false;
        if (state.AutofilledFields.includes("SerialVIN")) {
            state.SerialVIN = "";
        }
        if (state.AutofilledFields.includes("Manufacturer")) {
            state.ManufacturerSelected = "";
        }
        if (state.AutofilledFields.includes("Model")) {
            state.ModelSelected = "";
        }
        if (state.AutofilledFields.includes("Category")) {
            state.CategorySelected = "";
        }
        if (state.AutofilledFields.includes("Year")) {
            state.YearSelected = "";
        }
        state.AutofilledFields = [];
        this.handleFormUpdate(state);
        this.UpdateSpecList(state, true);
    }

    render() {

        let MLAutofillData = [];
        var foundCategory = this.state.CategoriesList.find((element) => element.Value == this.state.CategorySelected);
        let bMLCheckForFilledFields = this.state.MLAutofilled && (this.state.AutofilledFields.includes("Manufacturer") || this.state.AutofilledFields.includes("Model") || this.state.AutofilledFields.includes("Category") || this.state.AutofilledFields.includes("Year") || this.state.AutofilledFields.includes("SerialVIN"));
        var ManufacturerHighlighting = this.state.MLAutofilled && this.state.AutofilledFields.includes("Manufacturer") ? "autofillHighlight" : "";
        var ModelHighlighting = this.state.MLAutofilled && this.state.AutofilledFields.includes("Model") ? "autofillHighlight" : "";
        var CategoryHighlighting = this.state.MLAutofilled && this.state.AutofilledFields.includes("Category") && foundCategory != undefined && foundCategory.FullName != "" ? "autofillHighlight" : "#";
        var YearHighlighting = this.state.MLAutofilled && this.state.AutofilledFields.includes("Year") ? "autofillHighlight" : "";
        var SerialVINHighlighting = this.state.MLAutofilled && this.state.AutofilledFields.includes("SerialVIN") ? "autofillHighlight" : "";

        if (this.state.MLAutofilled) {
            if ((!bMLCheckForFilledFields && (foundCategory == undefined || foundCategory.FullName == "")) || (!bMLCheckForFilledFields && !this.state.AutofilledFields.includes("Category"))) {
                setTimeout(() => this.setState({ MLAutofilled: false }));
                MLAutofillData = []; //remove the autofill notification section if we're not filling any fields;
            }
            else {
                if (this.state.bAutofillRendered != true) {
                    setTimeout(() => this.setState({ bAutofillRendered: false }));
                }
                MLAutofillData.push(<p key="MLDataOverView"><strong style={{ fontSize: "15px" }}>{this.getTranslation("AbleToAutofill")}</strong></p>);
                if (this.state.AutofilledFields.includes("SerialVIN")) {
                    MLAutofillData.push(<p style={{ margin: "0px" }}><strong>{this.getTranslation("SerialVIN")}: </strong>{this.state.SerialVIN}</p>);
                }
                if (this.state.AutofilledFields.includes("Manufacturer")) {
                    MLAutofillData.push(<p style={{ margin: "0px" }}><strong>{this.getTranslation("Manufacturer")}: </strong>{this.state.ManufacturerSelected}</p>);
                }
                if (this.state.AutofilledFields.includes("Model")) {
                    MLAutofillData.push(<p style={{ margin: "0px" }}><strong>{this.getTranslation("Model")}: </strong>{this.state.ModelSelected}</p>);
                }
                if (this.state.AutofilledFields.includes("Category")) {
                    if (foundCategory != undefined && foundCategory.FullName != "") {
                        MLAutofillData.push(<p style={{ margin: "0px" }}><strong>{this.getTranslation("Category")}: </strong>{foundCategory.FullName}</p>);
                    }
                }
                if (this.state.AutofilledFields.includes("Year")) {
                    MLAutofillData.push(<p style={{ margin: "0px" }}><strong>{this.getTranslation("Year")}: </strong>{this.state.YearSelected}</p>);
                }
                MLAutofillData.push(<p key="MLDataUndo"><button type="button" onClick={(e) => { this.RemoveMLAutofillData(); }} style={{ textDecoration: 'underline', cursor: "pointer", color: "black" }}>{this.getTranslation("UndoAutofill")}</button></p>);

                MLAutofillData =
                    <div id="MLAutofillData" style={{ backgroundColor: 'rgb(0,0,0,0.1)', margin: "0px 0px 20px 0px", padding: "5px 15px 5px 15px" }}>
                        {MLAutofillData}
                    </div>
            }
        }

        var yearddl = [];
        for (var i = 0; i < this.state.Years.length; i++) {
            yearddl.push({ text: this.state.Years[i], value: this.state.Years[i] })
        };

        var categoryddl = [];
        for (var i = 0; i < this.state.CategoriesList.length; i++) {
            categoryddl.push({ text: this.state.CategoriesList[i], value: this.state.CategoriesList[i] })
        };

        var modelddl = [];
        for (var i = 0; i < this.state.ModelList.length; i++) {
            modelddl.push({ text: this.state.ModelList[i], value: this.state.ModelList[i] })
        };

        //mileage/hours spec options
        var specOptions = [];
        //don't even bother if we have empty category or empty specs
        if (this.state.CategorySelected != "0" && this.state.specsViewModel != null && this.state.specsViewModel.oMMMCategoryGroupSpecs.length > 0 && this.state.specsViewModel.GroupIndex >= 0) {
            var spec = this.state.specsViewModel.oMMMCategoryGroupSpecs[this.props.specsViewModel.GroupIndex].Specs[this.state.specsViewModel.SpecIndex];
            var selectname = spec.SpecField + "unit#";
            var selectvalues = [];
            if (spec.DatabaseUnit != null && spec.MeasurementUnitOptions != null) {
                for (var a = 0; a < spec.MeasurementUnitOptions.length; a++) {
                    for (var b = 0; b < this.state.specsViewModel.oMMMMeasurementUnit.length; b++) {
                        if (spec.MeasurementUnitOptions[a] == this.state.specsViewModel.oMMMMeasurementUnit[b].MeasurementUnitID) {
                            selectvalues.push({ text: this.state.specsViewModel.oMMMMeasurementUnit[b].Symbol, value: this.state.specsViewModel.oMMMMeasurementUnit[b].Unit })
                            break;
                        }
                    }
                }
            }

            specOptions.push(
                spec.MeasurementUnitOptions != null ?
                    <div className="form-row cf" key={10}>
                        <label className="label-left" htmlFor={spec.SpecField}>{spec.SpecField}{spec.Required ? <span> *</span> : ""}</label>
                        <div className="input-right">
                            <div className="input-left" style={{ width: 'calc(100% - 90px)' }}>
                                <TextField
                                    feRequired={spec.RecommendedForEvaluation}
                                    id={spec.SpecField}
                                    onBlur={(e) => { this.handleOnBlur("SpecField", e); }}
                                    value={this.state.specsViewModel.FormInputs[spec.SpecField].Value}
                                    onFieldChanged={(e) => { this.handleFieldChanged("SpecField", e); }}
                                    error={this.state.HighlightErrors[spec.SpecField]}
                                    errorText={this.state.InputErrors[spec.SpecField]}
                                    hasLabel={true}
                                />
                            </div>
                            <div className="labels-right">
                                <SelectField
                                    id={selectname}
                                    value={this.state.specsViewModel.FormInputs[selectname].Value}
                                    values={selectvalues}
                                    mileage={true}
                                    onFieldChanged={(e) => { this.handleFieldChanged("SpecUnit", e); }}
                                    error={this.state.HighlightErrors[selectname]}
                                    errorText={this.state.InputErrors[selectname]}
                                    hasLabel={true}
                                />
                            </div>
                        </div>
                    </div>
                    :
                    <div className="form-row cf" key={10}>
                        <label className="label-left" htmlFor={spec.SpecField}>{spec.Label}{spec.Required ? <span> *</span> : ""}</label>
                        <div className="input-right">
                            <TextField
                                feRequired={spec.RecommendedForEvaluation}
                                id={spec.SpecField}
                                onBlur={(e) => { this.handleOnBlur("SpecField", e); }}
                                value={this.state.specsViewModel.FormInputs[spec.SpecField].Value}
                                onFieldChanged={(e) => { this.handleFieldChanged("SpecField", e); }}
                                error={this.state.HighlightErrors[spec.SpecField]}
                                errorText={this.state.InputErrors[spec.SpecField]}
                                hasLabel={true}
                            />
                        </div>
                    </div>
            );
        }

        return (
            <form onSubmit={(e) => { e.preventDefault(); }} className="">
                <div className="validationError" style={{ textAlign: 'center' }}>
                    <span>{this.state.FormErrors}</span>
                </div>

                {MLAutofillData}

                {/*SerialVin*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="SerialVIN">Serial Number {this.state.SNRequired ? <span> *</span> : ""}</label>
                    <div className="input-right">
                        <TextField
                            feRequired={this.state.validFECat}
                            id="SerialVIN"
                            value={this.state.SerialVIN}
                            onFieldChanged={(e) => { this.handleFieldChanged("SerialVIN", e); }}
                            onBlur={(e) => { this.handleOnBlurUpdate(e); this.handleOnBlur("SerialVIN", e); }}
                            error={this.state.HighlightErrors.SerialVIN}
                            errorText={this.state.InputErrors.SerialVIN}
                            hasLabel={true}
                            highlight={SerialVINHighlighting}
                        />
                    </div>
                </div>

                {/*Manufacturer*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="ManufacturerSelected">{this.getTranslation("Manufacturer")} {this.state.bManufacturerIsRequired !== false ? <span> *</span> : ""}</label>
                    <div className="input-right">
                        <AutoCompleteField
                            feRequired={this.state.validFECat}
                            id="ManufacturerSelected"
                            value={this.state.ManufacturerSelected}
                            values={this.state.ManufacturersList}
                            onFieldChanged={(e, updateCat) => { this.handleFieldChanged("ManufacturerSelected", e, updateCat); }}
                            onBlur={(e) => { this.handleOnBlur("ManufacturerSelected", e); }}
                            error={this.state.HighlightErrors.ManufacturerSelected}
                            errorText={this.state.InputErrors.ManufacturerSelected}
                            hasLabel={true}
                            highlight={ManufacturerHighlighting}
                        />
                    </div>
                </div>

                {/*Model*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="ModelSelected">{this.getTranslation("Model")}{this.state.bModelIsRequired ? <span> *</span> : ""}</label>
                    <div className="input-right">
                        <AutoCompleteField
                            feRequired={this.state.validFECat}
                            id="ModelSelected"
                            value={this.state.ModelSelected}
                            values={this.state.ModelList}
                            onFieldChanged={(e, updateCat) => { this.handleFieldChanged("ModelSelected", e, updateCat); }}
                            onBlur={(e) => { this.handleOnBlur("ModelSelected", e); }}
                            error={this.state.HighlightErrors.ModelSelected}
                            errorText={this.state.InputErrors.ModelSelected}
                            hasLabel={true}
                            highlight={ModelHighlighting}
                        />
                    </div>
                </div>

                {/*Category*/}
                <div className="fe-section cf">
                    <div className="form-row cf">
                        <label className="label-left" htmlFor="CategorySelected">{this.getTranslation("Category")} <span>*</span></label>
                        <div className="input-right">
                            <SelectField
                                feRequired={this.state.validFECat}
                                id="CategorySelected"
                                value={this.state.CategorySelected}
                                values={this.state.CategoriesList}
                                onFieldChanged={(e) => { this.handleFieldChanged("CategorySelected", e); }}
                                bShowFullName={true}
                                error={this.state.HighlightErrors.CategorySelected}
                                errorText={this.state.InputErrors.CategorySelected}
                                hasLabel={true}
                                highlight={CategoryHighlighting}
                            />
                        </div>
                    </div>
                </div>

                {/*TailNumber*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="TailNumber"> Tail Number<span>*</span></label>
                    <div className="input-right">
                        <TextField
                            feRequired={this.state.validFECat}
                            id="TailNumber"
                            value={this.state.TailNumber}
                            onFieldChanged={(e) => { this.handleFieldChanged("TailNumber", e); }}
                            onBlur={(e) => { this.handleOnBlur("TailNumber", e); }}
                            error={this.state.HighlightErrors.TailNumber}
                            errorText={this.state.InputErrors.TailNumber}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/*Year*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="YearSelected">{this.getTranslation("Year")}{this.state.bYearIsRequired ? <span> *</span> : ""}</label>
                    <div className="input-right">
                        <SelectField
                            feRequired={this.state.validFECat}
                            id="YearSelected"
                            value={this.state.YearSelected}
                            values={yearddl}
                            onFieldChanged={(e) => { this.handleFieldChanged("YearSelected", e); }}
                            onBlur={(e) => { this.handleOnBlur("YearSelected", e); }}
                            error={this.state.HighlightErrors.YearSelected}
                            errorText={this.state.InputErrors.YearSelected}
                            hasLabel={true}
                            highlight={YearHighlighting}
                        />
                    </div>
                </div>

                {/*Location - City, State, Zip*/}
                <LocationPickerField
                    getTranslation={(key) => this.getTranslation(key)}
                    locationData={this.state.LocationViewModel}
                    onLocationChanged={(loc) => {
                        var highlightErrors = this.state.HighlightErrors;
                        var inputErrors = this.state.InputErrors;
                        delete highlightErrors.LocationPicker;
                        delete inputErrors.LocationPicker;
                        this.setState({ LocationViewModel: Object.assign(this.state.LocationViewModel, loc), HighlightErrors: highlightErrors, InputErrors: inputErrors }, () => {
                            this.props.handleFormUpdate(this.state);
                        });
                    }}
                    onValidation={(result) => {
                        var highlightErrors = this.state.HighlightErrors;
                        var inputErrors = this.state.InputErrors;
                        if (result.hasError) {
                            highlightErrors.LocationPicker = true;
                            inputErrors.LocationPicker = result.errorText;
                        } else {
                            delete highlightErrors.LocationPicker;
                            delete inputErrors.LocationPicker;
                        }
                        this.setState({ HighlightErrors: highlightErrors, InputErrors: inputErrors });
                    }}
                    onBlur={() => { this.props.handleFormUpdate(this.state); }}
                    highlightErrors={this.state.HighlightErrors}
                    inputErrors={this.state.InputErrors}
                    showWeeklyUpdateSubscriptionCheckbox={this.props.contactViewModel && this.props.contactViewModel.ShowWeeklyUpdateSubscriptionCheckbox}
                    onReceiveEmailsChanged={(val) => { if (this.props.contactViewModel) { this.props.contactViewModel.ReceiveEmails = val; } this.props.handleFormUpdate(this.state); }}
                />
            </form>
        );
    }
}

export default ListingDetailAircraftForm;
global.ListingDetailAircraftForm = ListingDetailAircraftForm;